import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { ALLOWED_MARKETS } from "@silvertours/common-landingpages-view";
import { http } from "@silvertours/front-shared";
function assertIsValidMarket(market) {
    if (!ALLOWED_MARKETS.includes(market)) {
        throw new Error("Value ".concat(market, " is not a MarketCode"));
    }
}
var getXWhitelabel = function(market) {
    assertIsValidMarket(market);
    switch(market){
        case "DE":
            return "DE_billiger-mietwagen";
        case "FR":
            return "FR_carigami";
        default:
            assertIsValidMarket(market);
            return "".concat(market, "_floyt");
    }
};
var authInterceptorGenerator = function(bearerAuth) {
    return function(config) {
        Object.assign(config.headers, {
            Authorization: bearerAuth
        });
        return config;
    };
};
var SuggestProvider = /*#__PURE__*/ function() {
    "use strict";
    function SuggestProvider(consumerApiSettings, language, market) {
        _class_call_check(this, SuggestProvider);
        this.token = null;
        this.searchSuggestionsCache = {};
        this.consumerApiSettings = consumerApiSettings;
        this.options = {
            headers: {
                "X-Whitelabel": getXWhitelabel(market),
                "Accept-Language": language
            }
        };
        this.suggestClient = http.getApi(consumerApiSettings.host, _object_spread({}, this.options), "");
        this.refreshToken();
    }
    var _proto = SuggestProvider.prototype;
    _proto.refreshToken = function refreshToken() {
        var _this = this;
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                if (!_this.token) {
                    http.getApi(_this.consumerApiSettings.host, {}, "").post(_this.consumerApiSettings.refreshTokenPath).then(function(result) {
                        var bearerAuth = "Bearer ".concat(result.data.token);
                        _this.token = bearerAuth;
                        var authInterceptor = authInterceptorGenerator(bearerAuth);
                        _this.suggestClient.interceptors.request.clear();
                        _this.suggestClient.interceptors.request.use(authInterceptor);
                    }).catch(function(e) {
                        if ("object" !== "undefined") {
                            var newrelic = window.newrelic;
                            newrelic === null || newrelic === void 0 ? void 0 : newrelic.noticeError(e);
                        }
                    });
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.keyExistsInCache = function keyExistsInCache(key) {
        return key in this.searchSuggestionsCache;
    };
    _proto.sendRequest = function sendRequest(searchString) {
        var _this = this;
        return _async_to_generator(function() {
            var searchSuggestions;
            return _ts_generator(this, function(_state) {
                if (_this.keyExistsInCache(searchString)) {
                    return [
                        2,
                        _this.searchSuggestionsCache[searchString]
                    ];
                }
                searchSuggestions = _this.suggestClient.request({
                    method: "get",
                    url: _this.consumerApiSettings.locationSuggest,
                    params: {
                        query: searchString,
                        context: "car_rental"
                    }
                }).then(function(result) {
                    var suggestionResults = result.data.map(function(param) {
                        var bm_code = param.bm_code, city_name = param.city_name, country_name = param.country_name, id = param.id, image_path = param.image_path, latitude = param.latitude, longitude = param.longitude, min_price = param.min_price, state_name = param.state_name, title = param.title, type = param.type, type_display = param.type_display, airport_code = param.airport_code, rail_code = param.rail_code;
                        return {
                            bmCode: bm_code,
                            cityName: city_name,
                            countryName: country_name,
                            id: id,
                            image_path: image_path,
                            latitude: latitude,
                            longitude: longitude,
                            minPrice: min_price,
                            objectID: id,
                            stateName: state_name,
                            title: title,
                            type: type,
                            typeDisplay: type_display,
                            airportCode: airport_code,
                            railCode: rail_code
                        };
                    });
                    _this.searchSuggestionsCache[searchString] = suggestionResults;
                    return suggestionResults;
                }).catch(function(e) {
                    if ("object" !== "undefined") {
                        var newrelic = window.newrelic;
                        newrelic === null || newrelic === void 0 ? void 0 : newrelic.noticeError(e);
                    }
                    return null;
                });
                return [
                    2,
                    searchSuggestions
                ];
            });
        })();
    };
    SuggestProvider.getInstance = function getInstance(consumerApiSettings, language, market) {
        if (!this.instance) {
            this.instance = new this(consumerApiSettings, language, market);
        }
        return this.instance;
    };
    return SuggestProvider;
}();
export { SuggestProvider };
